import { useDocumentTitle as useSetDocumentTitle } from 'usehooks-ts';
import { LocalizeTextProps, useLocalizeText } from '@mews/framework';

export function useCustomDocumentTitle(textProps: LocalizeTextProps) {
    const localizeText = useLocalizeText();
    useSetDocumentTitle(localizeText(textProps));
}
